import { Input, InputProps } from 'antd'
import './input-search.scss'

interface IInputSearch extends InputProps {
  placeholder?: string
}

const SearchIcon = () => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7" cy="7" r="5.5" stroke="#333333" />
    <path
      d="M9.82851 6C9.41667 4.83481 8.30543 4 6.99922 4C5.693 4 4.58176 4.83481 4.16992 6"
      stroke="#333333"
    />
    <path d="M11 11L14 14" stroke="#333333" />
  </svg>
)

export const InputSearch = ({
  placeholder = 'Поиск',
  style,
  ...rest
}: IInputSearch) => {
  return (
    <Input
      className="input-search-container"
      placeholder={placeholder}
      style={style}
      suffix={<SearchIcon />}
      {...rest}
    />
  )
}
